export default "* Fødekæde\n* Planteæder\n* Kødæder";